import { useLocation } from 'react-router-dom';
import { PanelLeftClose, PanelLeft } from 'lucide-react';
import { useUIStore } from '@/stores/ui';
import { getCurrentSection } from '@/config/navigation';
import { NavItem } from './NavItem';

export function Sidebar() {
  const location = useLocation();
  const { sidebarCollapsed, toggleSidebar } = useUIStore();
  const currentSection = getCurrentSection(location.pathname);

  return (
    <aside
      className={`
        flex h-full flex-col border-r border-border bg-background-subtle
        transition-all duration-200 ease-in-out
        ${sidebarCollapsed ? 'w-14' : 'w-52'}
      `}
    >
      {/* Section title & collapse toggle */}
      <div className={`flex h-10 items-center border-b border-border px-3 ${sidebarCollapsed ? 'justify-center' : 'justify-between'}`}>
        {!sidebarCollapsed && (
          <span className="text-xs font-semibold uppercase tracking-wider text-foreground-subtle">
            {currentSection.label}
          </span>
        )}
        <button
          onClick={toggleSidebar}
          className="
            flex h-6 w-6 items-center justify-center rounded
            text-foreground-muted hover:bg-background-hover hover:text-foreground
            transition-colors
          "
          aria-label={sidebarCollapsed ? 'Expand sidebar' : 'Collapse sidebar'}
        >
          {sidebarCollapsed ? (
            <PanelLeft className="h-4 w-4" />
          ) : (
            <PanelLeftClose className="h-4 w-4" />
          )}
        </button>
      </div>

      {/* Contextual navigation */}
      <nav className="flex-1 overflow-y-auto py-2 px-2">
        <div className="space-y-0.5">
          {currentSection.subNav.map((item) => (
            <NavItem
              key={item.path}
              to={item.path}
              icon={<item.icon className="h-4 w-4" />}
              label={item.label}
              collapsed={sidebarCollapsed}
            />
          ))}
        </div>
      </nav>
    </aside>
  );
}
